const EXTERNAL_HOSTS = [
    "images.pexels.com",
    "upload.wikimedia.org",
    "thumb.wikimedia.org",
];

export function isExternalHost(url) {
    if (!url) {
        return false;
    }
    try {
        return EXTERNAL_HOSTS.includes(
            new URL(url, window.location.origin).hostname
        );
    } catch {
        return false;
    }
}
